import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import GuaranteeBar from "@/components/GuaranteeBar";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Tariffe from "@/components/Tariffe";
import B2B from "@/components/B2B";
import HowItWorks from "@/components/HowItWorks";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -96 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#060B19] text-white">
      <Toaster position="top-center" theme="dark" />
      <Header />
      <main>
        <Hero />
        <GuaranteeBar />
        <Marquee />
        <Services />
        <Tariffe />
        <B2B />
        <HowItWorks />
        <Faq />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}

export default App;
